module.exports = __webpack_public_path__ + "static/media/success-1.dbf7b13f.svg";